{
  "title": "FAQ",
  "accordion": [
    {
      "title": "Как создать новую вакансию?",
      "items": [
        {
          "question": "Как добавить сотрудника компании",
          "steps": [
            "1. Перейдите в раздел \"Сотрудники\" в основном меню.",
            "2. Нажмите кнопку \"Добавить нового сотрудника\" или \"Создать\".",
            "3. Введите имя сотрудника в соответствующее поле.",
            "4. Заполните остальные обязательные поля (например, должность, отдел, контактные данные).",
            "5. Выберите компанию из списка или введите название компании, если она еще не добавлена.",
            "6. Нажмите кнопку \"Сохранить\" для завершения добавления."
          ]
        }
      ]
    },
    {
      "title": "Тарифы подбора кандидатов",
      "items": [
        {
          "question": "Что такое тариф вакансии?",
          "paragraphs": [
            "Тариф вакансии - функционал платформы для подбора соискателей на вакансию.",
            "Условиями тарифа регулируется принцип подбора кандидатов и механизм взаимодействия с ними.",
            "Описание условий тарифа можно просмотреть на детальной странице вакансии с соответствующем блоке.",
            "На текущий момент основным тарифом является “Свайп”.",
            "Он позволяет просмотреть основную информацию кандидата и оставить решение по найму самостоятельно."
          ]
        },
        {
          "question": "Как выбрать кандидата через \"Свайп\"?",
          "paragraphs": [
            "Перейдите на страницу вакансии и в блоке “Выбранные кандидаты” кликните по кнопке “Подобрать”.",
            "Откроется блок с карточками кандидатов, подобранных Синтией для вакансии.",
            "Кнопками “Выбрать” или “Отказать” вы можете указать решение по кандидату.",
            "После отказа данный кандидат более не будет отображать в рекомендациях на выбранную вакансию.",
            "После одобрения кандидата вам станет доступным полный номер телефона для дальнейшей коммуникации с кандидатом."
          ]
        },
        {
          "question": "Что делать, если нет рекомендаций по кандидатам?",
          "paragraphs": [
            "В случае, если после обработки списка кандидатов ни один из них не был одобрен, то вы можете запросить у Синтии новый подбор, кликнув по кнопке “Подобрать”.",
            "После повторной проверки базы кандидатов, список будет наполнен новыми соискателями.",
            "В случае, если на момент запроса не будет подходящих кандидатов, то вы увидите соответствующее сообщение и сможете отправить запрос повторно спустя некоторое время."
          ]
        }
      ]
    },
    {
      "title": "Синтия для работодателей",
      "items": [
        {
          "question": "Как Синтия может помочь найти работников?",
          "paragraphs": [
            "С помощью Синтии вы можете создать новую вакансию просто указав описание самой вакансии и требования к кандидату.",
            "Для этого на странице списка вакансий кликните по кнопке “Создать” и выберите пункт “Сгенерировать вакансию”.",
            "В открывшемся окне в свободной форме введите всю необходимую информацию, какую посчитаете нужной, и кликните “Сгенерировать”.",
            "После обработки, вы будете перенаправлены на страницу создания вакансии, в которой Синтия заполнит все поля формы, для которых будет достаточно контекста.",
            "Вы сможете вручную скорректировать значения в полях и далее закончить создание вакансии."
          ]
        },
        {
          "question": "Что еще может Синтия?",
          "paragraphs": [
            "В разделе “Диалог с Синтией” вы можете задать интересующие вас вопросы по вакансиям, условиям труда, сферам деятельности и другим темам, которые помогут вам в создании вакансии, а также подборе сотрудников для них.",
            "Вы можете отправлять голосовые сообщения Синтии, которые будут расшифрованы и дополнительно отображены текстом для удобства общения."
          ]
        },
        {
          "question": "Я не знаю, какую сферу деятельности указать для вакансии.",
          "paragraphs": [
            "На странице создания или редактирования вакансии установите переключатель “Автоподбор сферы деятельности” в активное положение и Синтия поможет в заполнении этого поля.",
            "Для заполнения формы будет использоваться контекст названия и описания вакансии, а также требований к кандидатам."
          ]
        }
      ]
    },
    {
      "title": "Копирование вакансии",
      "items": [
        {
          "question": "Можно ли копировать существующие активные или закрытые вакансии?",
          "paragraphs": [
            "Да, вы можете создать копию вакансии кликнув по соответствующей кнопке действия в общем списке вакансией вашей компании.",
            "Откроется форма создания новой вакансии, поля которой будут автоматически заполнены данными исходной вакансии.",
            "Все поля будут доступны для редактирования и вы сможете создать точную копию, либо создать новую вакансию с измененными данными."
          ]
        },
        {
          "question": "Будут ли перенесены подобранные кандидаты исходной вакансии в копию?",
          "paragraphs": [
            "Нет, подобранные или одобренные кандидаты не будут перенесены в копию.",
            "Это будет совершенно новая вакансия, для которой кандидаты будут подбираться повторно, даже если изменений в условия вакансии не было внесено."
          ]
        }
      ]
    }
  ]
}
